/* eslint-disable react/button-has-type */
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error?: Error;
}

/**
 * 모듈 렌더링 오류를 처리하는 에러 바운더리 컴포넌트
 */
export class ModuleErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('모듈 렌더링 오류:', error, errorInfo);
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onError?.(error, errorInfo);
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError) {
      return (
        // eslint-disable-next-line react/destructuring-assignment
        this.props.fallback
      );
    }

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}
